// MOMENT TIMEZONE NOTES
// - we can't use moment.tz.names() because moment and php appear to take a different aproach to compiling the IANA OLSEN DB for distribution
// - moment-timezone uses all available timezones in the db
// - php timezone compiles against either the zone.tab or zone1970.tab likely depending on the version
// - (zone1970 appears to have been created to supersede zone.tab on 2018-06-17).
// - moment thus contains all entries php does, so we can use a list generated by php for now

import { get } from "lodash";
import moment from "moment-timezone";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Field } from "formik";

import FormikSemanticDropdown from "../formik/FormikSemanticDropdown.jsx";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class FormikTimezoneDropdown extends PureComponent {
  static propTypes = {
    required: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    apiErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    required: false,
    readOnly: false,
    disabled: false,
    copyKey: "forms.timezone_dropdown"
  };

  // -- HANDLERS -- //

  onChange = (evt, data, form) => {
    const { timezoneData } = this.props;

    const name = get(this.props, "field.name", "timezonedefault");

    const entity = timezoneData[data.value];

    form.setFieldValue(name, entity);
  };

  // -- RENDER -- //

  guessDefaultTimezone = () => {
    const { field, timezoneIndex, timezoneData } = this.props;

    const timezone = get(field, "values.timezone", null);

    let defaultTimezone = null;

    if (timezone) {
      defaultTimezone = timezone;
    } else {
      const timezoneValue = moment.tz.guess();
      defaultTimezone = timezoneIndex.find(id => {
        return timezoneData[id].value === timezoneValue;
      });
    }

    return defaultTimezone;
  };

  getTimezoneOptions = () => {
    const { timezoneIndex, timezoneData } = this.props;

    return timezoneIndex.map(id => {
      const item = timezoneData[id];

      return {
        key: item["@id"],
        text: item.value,
        value: item["@id"]
      };
    });
  };

  render() {
    const {
      field: { name },
      required,
      readOnly,
      disabled,
      apiErrors,
      copyKey,
      copy
    } = this.props;

    return (
      <Field
        name={`${name}.@id`}
        placeholder={copy(`${copyKey}.placeholder`)}
        label={copy(`${copyKey}.label`)}
        required={required}
        fluid
        search
        selection
        options={this.getTimezoneOptions()}
        onChange={this.onChange}
        readOnly={readOnly}
        disabled={disabled}
        apiErrors={apiErrors}
        component={FormikSemanticDropdown}
      />
    );
  }
}

const mapStateToProps = state => ({
  timezoneIndex: state.timezones.dataIndex,
  timezoneData: state.timezones.dataMap,
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(FormikTimezoneDropdown);
